export const storeInitializer = (defaultValues) => (set, get) => ({
  next: [],
  prev: [],

  add(item) {
    const { prev } = get();
    const nextPrev = [...prev];

    nextPrev.push(item);

    set({
      prev: nextPrev,
    });
  },

  undo() {
    const { prev, next } = get();
    const toMove = prev.pop();
    const res = prev[prev.length - 1];

    set({
      prev: [...prev],
      next: [toMove, ...next],
    });

    return res;
  },

  redo() {
    const { prev, next } = get();
    const item = next[0];

    set({
      prev: [...prev, item],
      next: next.slice(1),
    });

    return item;
  },

  getAll() {
    const { prev, next } = get();

    return { prev, next } as const;
  },

  setAll({ prev, next }) {
    set({
      prev,
      next,
    });
  },
  ...defaultValues,
});
